import {Component} from '@angular/core';
import {DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {Impresa} from "../../../../models/impresa.model";
import {RegioneDTO} from "../../../../models/regione.model";
import {MessageService, SelectItem, SelectItemGroup} from "primeng/api";
import {CompoMovimentazione} from "../stato-movimentazioni.component";
import {MagazzinoApiDescriptor, ModelloDispositivoApiDescriptor, MovimentazioneApiBuilder, ScuolaPraticaApiDescriptor, TipoMovimentazione} from "../../../../models/magazzino.model";
import {dateAsYYYYMMDD} from "../../../../lib/support";
import {MagazzinoService} from "../../../../services/magazzino.service";
import {environment} from "../../../../../environments/environment";

@Component({
  selector: 'app-movimentazione-edit-create-dialog',
  templateUrl: './movimentazione-edit-create-dialog.component.html',
  styleUrls: ['./movimentazione-edit-create-dialog.component.scss']
})
export class MovimentazioneEditCreateDialogComponent {

	hasValidForm: boolean;

	// these options show which fields are needed and how they are verified
	dialog_has_mag_from: boolean;
	dialog_has_mag_to: boolean;
	dialog_has_mag_ref: boolean;
	dialog_has_pratica: boolean;
	dialog_has_direction: boolean;
	dialog_has_autotransfer: boolean;
	dialog_has_materials_select: boolean;

	movtype: TipoMovimentazione;
	reqfirm: Impresa;

	optionsMagRef: SelectItem<MagazzinoApiDescriptor>[];
	optionsMagFrom: SelectItemGroup[];
	optionsMagTo: SelectItemGroup[];
	optionsMateriali: SelectItem<ModelloDispositivoApiDescriptor>[];
	optionsScuole: SelectItem<ScuolaPraticaApiDescriptor>[];

	edits_magRef: MagazzinoApiDescriptor;
	edits_magFrom: MagazzinoApiDescriptor;
	edits_magTo: MagazzinoApiDescriptor;
	edits_praticaScuola: ScuolaPraticaApiDescriptor;
	edits_direction_incoming: boolean;

	edits_notes: string;

	edits_movdate: Date = new Date();
	max_date: Date = new Date();

	edits_materiali: {
		modello:		ModelloDispositivoApiDescriptor,
		qt:				number;
	}[];
	active_materials: string[];
	currentOptionMateriali: ModelloDispositivoApiDescriptor;

	// FOR DEBUG ONLY
	AZIENDA_ID_TELECOM = environment.magazzino.aziendaid_TIM ?? 2;

	lockedMagFrom: boolean;
	lockedMagTo: boolean;

	materialsByDepot: {[key: string]: {[key: string]: number}};

	warningMaterialsUnavailable: boolean;

	constructor (
		public ref: DynamicDialogRef,
		public config: DynamicDialogConfig<MovimentazioneEditCreateDialogConfig>,
		private messages: MessageService,
		private backendMagazzino: MagazzinoService
	) {
		this.movtype = config.data.movtype;
		this.reqfirm = config.data.reqfirm;

		this.edits_notes = config.data.src?.note ?? "";

		this.edits_materiali = [];
		this.refreshAvailableMaterialsList();

		this.optionsScuole = [];

		// console.log(this.movtype, this.reqfirm);
		// console.log("scuole", this.config.data.scuole);

		this.warningMaterialsUnavailable = false;

		this.lockedMagFrom = false;
		this.lockedMagTo = false;

		this.setUI();
		this.resetMaterialsAvailability();
	}

	setUI () {

		// console.log("setting UI for ", this.movtype);
		if (this.movtype == TipoMovimentazione.ALLINEAMENTO_TIM) {
			this.dialog_has_direction = true;
			this.dialog_has_mag_from = false;
			this.dialog_has_mag_to = false;
			this.dialog_has_mag_ref = true;
			this.dialog_has_pratica = false;
			this.dialog_has_autotransfer = false;
			this.dialog_has_materials_select = true;

			this.optionsMagRef = this.config.data.magazzini.filter((item) => {
				return item.azienda == this.AZIENDA_ID_TELECOM;
			}).map((item) => {
				return {label: item.codice, value: item}
			});
			this.edits_magRef = this.optionsMagRef.length == 1 ? this.optionsMagRef[0].value : null;
			
			this.edits_direction_incoming = true;
		} else if (this.movtype == TipoMovimentazione.ALLINEAMENTO_IMPRESA) {
			this.dialog_has_direction = true;
			this.dialog_has_mag_from = false;
			this.dialog_has_mag_to = false;
			this.dialog_has_mag_ref = true;
			this.dialog_has_pratica = false;
			this.dialog_has_autotransfer = false;
			this.dialog_has_materials_select = true;

			this.optionsMagRef = this.config.data.magazzini.filter((item) => {
				return item.azienda == this.reqfirm.id;
			}).map((item) => {
				return {label: item.codice, value: item}
			}).sort((itemA, itemB) => {
				return itemA.label.localeCompare(itemB.label);
			});
			this.edits_magRef = this.optionsMagRef.length == 1 ? this.optionsMagRef[0].value : null;

		} else if (this.movtype == TipoMovimentazione.TIM_IMPRESA) {
			this.dialog_has_direction = false;
			this.dialog_has_mag_from = true;
			this.dialog_has_mag_to = true;
			this.dialog_has_mag_ref = false;
			this.dialog_has_pratica = false;
			this.dialog_has_autotransfer = true;
			this.dialog_has_materials_select = true;

			this.optionsMagTo = this.getMagOptions(this.config.data.imprese.filter((item) => {
				return item.id != this.AZIENDA_ID_TELECOM;
			})).filter((item) => {
				return item.items.length > 0;
			});
			this.optionsMagFrom = this.getMagOptions(this.config.data.imprese.filter((item) => {
				return item.id == this.AZIENDA_ID_TELECOM;
			}));

			this.edits_magFrom = this.optionsMagFrom[0].items.length == 1 ? this.optionsMagFrom[0].items[0].value : null;
			this.lockedMagFrom = this.edits_magFrom != null;
			this.edits_magTo = null;

			// console.log("mags from ", this.optionsMagFrom, "mags to", this.optionsMagTo);
			// console.log("edits from", this.edits_magFrom);
		} else if (this.movtype == TipoMovimentazione.IMPRESA_TIM) {
			this.dialog_has_direction = false;
			this.dialog_has_mag_from = true;
			this.dialog_has_mag_to = true;
			this.dialog_has_mag_ref = false;
			this.dialog_has_pratica = false;
			this.dialog_has_autotransfer = true;
			this.dialog_has_materials_select = true;

			this.optionsMagFrom = this.getMagOptions(this.config.data.imprese.filter((item) => {
				return item.id == this.reqfirm.id;
			}));
			this.optionsMagTo = this.getMagOptions(this.config.data.imprese.filter((item) => {
				return item.id == this.AZIENDA_ID_TELECOM;
			}));

			this.edits_magTo = this.optionsMagTo[0].items.length == 1 ? this.optionsMagTo[0].items[0]?.value : null;


			this.edits_magFrom = this.optionsMagFrom[0].items.length == 1 ? this.optionsMagFrom[0].items[0]?.value : null;

			this.lockedMagFrom = this.edits_magFrom != null;
			this.lockedMagTo = this.edits_magTo != null;

		} else if (this.movtype == TipoMovimentazione.MAGAZZINO_MAGAZZINO) {
			this.dialog_has_direction = false;
			this.dialog_has_mag_from = true;
			this.dialog_has_mag_to = true;
			this.dialog_has_mag_ref = false;
			this.dialog_has_pratica = false;
			this.dialog_has_autotransfer = true;
			this.dialog_has_materials_select = true;

			this.optionsMagFrom = this.getMagOptions(this.config.data.imprese.filter((item) => {
				return item.id == this.reqfirm.id;
			}));

			// telecom CANNOT make mag2mag to others and other cannot make mag2mag to TELECOM, just for tagging purpose though
			const impreseTo = this.reqfirm.id == this.AZIENDA_ID_TELECOM ? [this.reqfirm] : this.config.data.imprese.filter((item) => { return item.id != this.AZIENDA_ID_TELECOM});
			this.optionsMagTo = this.getMagOptions(impreseTo, this.reqfirm).filter((item) => {
				return item.items.length > 0;
			});
		} else if (this.movtype == TipoMovimentazione.IMPRESA_INSTALLAZIONE) {

			this.dialog_has_direction = false;
			this.dialog_has_mag_from = true;
			this.dialog_has_mag_to = false;
			this.dialog_has_mag_ref = false;
			this.dialog_has_pratica = true;
			this.dialog_has_autotransfer = true;
			this.dialog_has_materials_select = true;

			this.optionsScuole = this.config.data.scuole.filter((item) => {
				return item.pratica.stato_ff2 == 31 && item.pratica.azienda == this.reqfirm.id;
			}).map((item) => {
				return {
					label: `${item.pratica.cui}`,
					value: {...item, cui: item.pratica.cui}
				}
			}).sort((itemA, itemB) => {
				return itemA.label.localeCompare(itemB.label);
			});
			this.edits_praticaScuola = this.optionsScuole.length == 1 ? this.optionsScuole[0].value : null;
			// console.log("OPTS SCUOLE: ", this.optionsScuole);

			this.optionsMagFrom = this.getMagOptions(this.config.data.imprese.filter((item) => {
				return item.id == this.reqfirm.id;
			}));
			this.edits_magFrom = this.optionsMagFrom[0].items.length == 1 ? this.optionsMagFrom[0].items[0]?.value : null;

			this.lockedMagFrom = this.edits_magFrom != null;
			this.lockedMagTo = this.edits_magTo != null;
		}
		// console.log("set ui w scorte ", this.materialsByDepot);
		// console.log("opzioni scuole ", this.optionsScuole);
	}

	resetMaterialsAvailability () {
		// console.log("REQFIRM", this.reqfirm);

		const byDepotByModelId = {};
		this.backendMagazzino.scorteCorrentiList(this.reqfirm.id).subscribe((result) => {
			for (let item of result.listing) {
				if (!byDepotByModelId[item.cod_magazzino]) {
					byDepotByModelId[item.cod_magazzino] = {};
				}
				byDepotByModelId[item.cod_magazzino][item.rif_modello] = item.balance;
			}

			// adding missing ones
			for (let material of this.config.data.materiali) {
				for (let mag of Object.keys(byDepotByModelId)) {
					if (!byDepotByModelId[mag].hasOwnProperty(material.id)) {
						byDepotByModelId[mag][material.id] = 0;
					}
				}
			}
			this.materialsByDepot = byDepotByModelId;
			// console.log("materials ready: ", this.materialsByDepot);
			this.refreshAvailableMaterialsList();

		});

	}

	getAziendaMagOptions (impresa: Impresa): SelectItem<MagazzinoApiDescriptor>[] {
		return this.config.data.magazzini.filter((mag) => {
			return mag.azienda == impresa.id;
		}).sort((a,b) => {
			return a.codice.localeCompare(b.codice);
		}).map((mag) => {
			return {
				label: mag.codice,
				value: mag
			}
		})
	}

	getMagOptions (imprese: Impresa[], main?: Impresa): SelectItemGroup[] {
		return imprese.sort((a, b) => {
			if (main && (a.id == main.id || b.id == main.id)) {
				return a.id == main.id ? -1 : 1;
			} else {
				return a.ragioneSociale.localeCompare(b.ragioneSociale);
			}

		}).map((item) => {
			return {
				label: item.ragioneSociale,
				value: item.id,
				items: this.getAziendaMagOptions(item)
			}
		});
	}

	onChangeDirection () {
		this.refreshAvailableMaterialsList();
		this.verifyForm();
	}

	onChangeDepotFrom () {
		this.refreshAvailableMaterialsList();
		this.verifyForm();
	}

	onChangeDepotRef () {
		this.refreshAvailableMaterialsList();
		this.verifyForm();
	}

	refreshAvailableMaterialsList () {
		this.active_materials = this.edits_materiali.map((item) => { return item.modello.id});
		let matAvail: {[key: string]: number} = null;
		if (this.dialog_has_mag_from && this.edits_magFrom) {
			matAvail = {...this.materialsByDepot[this.edits_magFrom.codice]};
		} else if (this.dialog_has_mag_ref && (!this.edits_direction_incoming) && this.edits_magRef) {
			matAvail = {...this.materialsByDepot[this.edits_magRef.codice]};
		}
		this.optionsMateriali = this.config.data.materiali.filter((item) => {
			return matAvail == null || this.active_materials.indexOf(item.id) == -1;
		}).map((item) => {
			const inScorta =  matAvail == null ||  (matAvail[item.id] ?? 0) > 0;
			return { label: `${item.nmu}: ${item.descrizione}`, value: item, disabled: !inScorta }
		}).sort((itemA, itemB) => {
			if (itemA.disabled != itemB.disabled) {
				return itemA.disabled ? 1 : -1;
			} else {
				return itemA.label.localeCompare(itemB.label);
			}
		});
		// console.log(this.optionsMateriali);
	}


	removeFromMaterialsList (key: string) {
		const idx = this.edits_materiali.findIndex((item) => {
			return item.modello.id == key;
		});
		if (idx != -1) {
			this.edits_materiali.splice(idx, 1);
		}
		this.refreshAvailableMaterialsList();
		this.verifyForm();
	}

	addToMaterialsList () {
		this.edits_materiali.push({modello: this.currentOptionMateriali, qt: 1});
		this.currentOptionMateriali = null;
		this.refreshAvailableMaterialsList();
		this.verifyForm();
	}

	formHasValidMaterialsList () {
		const hasMaterialsList = this.edits_materiali.find((item) => { return item.qt > 0});

		let magForCheck: MagazzinoApiDescriptor = null;
		if (this.dialog_has_mag_from) {
			magForCheck = this.edits_magFrom;
		} else if (this.dialog_has_mag_ref && !this.edits_direction_incoming) {
			magForCheck = this.edits_magRef;
		}

		let areMaterialsAvailable = true;
		if (magForCheck != null) {
			areMaterialsAvailable = this.edits_materiali.every((item) => {
				return item.qt <= this.materialsByDepot[magForCheck.codice][item.modello.id];
			})
		}

		this.warningMaterialsUnavailable = !areMaterialsAvailable;

		return hasMaterialsList && areMaterialsAvailable;
	}

	verifyForm () {
		if (this.movtype == TipoMovimentazione.ALLINEAMENTO_TIM || this.movtype == TipoMovimentazione.ALLINEAMENTO_IMPRESA) {
			if (!this.formHasValidMaterialsList()) {
				// console.log("materials issue: ", this.edits_materiali);
				this.hasValidForm = false;
				return;
			}
			
			if (this.edits_movdate == null || this.edits_magRef == null) {
				// console.log("date/mag issue", this.edits_movdate, this.edits_magRef);
				this.hasValidForm = false;
				return;
			}
		} else if (this.movtype == TipoMovimentazione.TIM_IMPRESA  || this.movtype == TipoMovimentazione.MAGAZZINO_MAGAZZINO || this.movtype == TipoMovimentazione.IMPRESA_TIM) {
			// console.log(this.edits_magFrom, this.edits_magTo);
			if (!this.formHasValidMaterialsList()) {
				// console.log("materials issue: ", this.edits_materiali);
				this.hasValidForm = false;
				return;
			}

			if (this.edits_movdate == null || this.edits_magFrom == null || this.edits_magTo == null || this.edits_magFrom.id == this.edits_magTo.id) {
				// console.log("date/mag issue", this.edits_movdate, this.edits_magFrom, this.edits_magTo);
				this.hasValidForm = false;
				return;
			}
		} else if (this.movtype == TipoMovimentazione.IMPRESA_INSTALLAZIONE) {
			if (!this.formHasValidMaterialsList()) {
				// console.log("materials issue: ", this.edits_materiali);
				this.hasValidForm = false;
				return;
			}

			if (this.edits_movdate == null || this.edits_magFrom == null || this.edits_praticaScuola == null) {
				// console.log("date/mag issue", this.edits_movdate, this.edits_magFrom, this.edits_magTo);
				this.hasValidForm = false;
				return;
			}
		}
		
		this.hasValidForm = true;
	}

	assembleMovimentazione () {
		let movOut: MovimentazioneApiBuilder = null;
		if (this.movtype == TipoMovimentazione.ALLINEAMENTO_TIM || this.movtype == TipoMovimentazione.ALLINEAMENTO_IMPRESA) {
			const matlist = {};
			for (let mat of this.edits_materiali) {
				matlist[mat.modello.id] = mat.qt
			}
			movOut = {
				tipo: this.movtype,
				pratica: null,
				materiali: matlist,
				destinazione: this.edits_direction_incoming ? this.edits_magRef.id : null,
				origine: this.edits_direction_incoming ? null : this.edits_magRef.id,
				data_richiesta: dateAsYYYYMMDD(this.edits_movdate, "-"),
				note: this.edits_notes
			}
		} else if (this.movtype == TipoMovimentazione.TIM_IMPRESA || this.movtype == TipoMovimentazione.MAGAZZINO_MAGAZZINO || this.movtype == TipoMovimentazione.IMPRESA_TIM) {
			const matlist = {};
			for (let mat of this.edits_materiali) {
				if (mat.qt > 0) {
					matlist[mat.modello.id] = mat.qt;
				}
			}
			movOut = {
				tipo: this.movtype,
				pratica: null,
				materiali: matlist,
				origine: this.edits_magFrom.id,
				destinazione: this.edits_magTo.id,
				data_richiesta: dateAsYYYYMMDD(this.edits_movdate, "-"),
				note: this.edits_notes
			}
		} else if (this.movtype == TipoMovimentazione.IMPRESA_INSTALLAZIONE) {
			const matlist = {};
			for (let mat of this.edits_materiali) {
				if (mat.qt > 0) {
					matlist[mat.modello.id] = mat.qt;
				}
			}
			movOut = {
				tipo: this.movtype,
				pratica: this.edits_praticaScuola.pratica.id,
				materiali: matlist,
				origine: this.edits_magFrom.id,
				destinazione: null,
				data_richiesta: dateAsYYYYMMDD(this.edits_movdate, "-"),
				note: this.edits_notes
			}
		}
		return movOut;
	}

	onActivityCompleted (confirm: boolean) {
		this.ref.close(confirm ? this.assembleMovimentazione() : null);
	}
}

interface MovimentazioneEditCreateDialogConfig {
	reqfirm?: 			Impresa;
	movtype: 			TipoMovimentazione;
	src?: 				CompoMovimentazione;
	magazzini: 			MagazzinoApiDescriptor[];
	imprese: 			Impresa[];
	regioni: 			RegioneDTO[];
	materiali:			ModelloDispositivoApiDescriptor[];
	scuole:				ScuolaPraticaApiDescriptor[];
}

